function colorSwatchUpdate() {
  document.querySelectorAll(".collection-swatches").forEach(productCard => {
    const colorOptions = productCard.querySelectorAll(".color-option");
    const sizeOptions = productCard.querySelectorAll(".size-option");
    const productImage = productCard.querySelector(".productImage");

    if (!productImage) return;

    productImage.style.display = "none";

    colorOptions.forEach(option => {
      option.addEventListener("click", function () {
        const selectedColor = this.getAttribute("data-color");

        // Remove active class from all
        colorOptions.forEach(opt => opt.classList.remove("active"));
        this.classList.add("active");

        // Update image
        const image = this.getAttribute("data-image");
        if (image) {
          productImage.src = image;
          productImage.style.display = "block";
        }

        // Update size swatches to show correct images
        sizeOptions.forEach(sizeOpt => {
          const size = sizeOpt.getAttribute("data-size");
          const matched = productCard.querySelector(`.size-option[data-size="${size}"][data-color="${selectedColor}"]`);
          if (matched) {
            sizeOpt.setAttribute("data-image", matched.getAttribute("data-image"));
          }
        });
      });
    });
  });
}

function sizeSwatchUpdate() {
  document.querySelectorAll(".collection-swatches").forEach(productCard => {
    const sizeOptions = productCard.querySelectorAll(".size-option");
    const productImage = productCard.querySelector(".productImage");

    if (!productImage) return;

    sizeOptions.forEach(option => {
      option.addEventListener("click", function () {
        const newImageSrc = this.getAttribute("data-image");

        // Remove 'active' class from all size options
        sizeOptions.forEach(opt => opt.classList.remove("active"));
        this.classList.add("active");

        if (newImageSrc) {
          productImage.src = newImageSrc;
          productImage.style.display = "block";
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  colorSwatchUpdate();
  sizeSwatchUpdate();
});
